const yogaInstructorDetailedRateCard = {
  key: "yoga-instructor",
  title: "Yoga Instructor Detailed Rate Card",
  note:
    "Indicative yoga pricing. Final rates depend on session frequency, whether sessions are individual or group, and instructor specialization.",
  sections: [
    {
      title: "Single Sessions",
      items: [
        { name: "Single yoga session", price: "₹499 per session" },
      ],
    },
    {
      title: "Plans",
      items: [
        { name: "Weekly yoga plan", price: "₹1499 onwards" },
        { name: "Monthly yoga plan", price: "₹3999 onwards" },
      ],
    },
    {
      title: "Consultation",
      items: [
        { name: "Yoga goal consultation", price: "₹249" },
      ],
    },
  ],
};

export default yogaInstructorDetailedRateCard;